var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100vh"}},[(_vm.isLoading)?_c('div',{staticClass:"text-center mt-10 mb-10"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"secondary"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }